import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings";
import {SectionDescription} from "components/misc/Typography";
import { ReactComponent as LinkedinIcon} from "images/linkedin-icon.svg";
import { useLazyLoad } from "../hook/useLazyLoad.js";

const HeadingContainer = tw.div``
const Heading = tw(SectionHeading)``
const Subheading = tw(SubheadingBase)`text-center mb-3`
const Description = tw(SectionDescription)`mx-auto text-center`

const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`
const Card = tw.div`mt-24 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center`
const CardImage = styled.div`
  ${tw`w-64 h-64 bg-contain bg-center rounded`}
`;

const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase font-bold tracking-widest text-xs text-primary-500`}
  }
  .name {
    ${tw`mt-1 text-xl font-medium text-gray-900`}
  9
`
const LazyImage = ({ imageSrc, ...props }) => {
  const { isLoaded, containerRef } = useLazyLoad(imageSrc);

  return (
    <CardImage
      ref={containerRef}
      {...props}
      style={{
        backgroundImage: isLoaded ? `url(${imageSrc})` : "none", // Mostrar la imagen de fondo cuando esté cargada
        backgroundColor: isLoaded ? "transparent" : "#f0f0f0", // Añadir color de fondo temporal mientras se carga
        minHeight: "200px", // Asegurar una altura mínima para evitar saltos de contenido
        transition: "background-image 0.3s ease-in-out, background-color 0.3s ease-in-out", // Transición suave
      }}
    />
  );
};

const CardLinks = styled.div`
  ${tw`mt-6 flex`}
  .link {
    ${tw`mr-8 last:mr-0 text-gray-400 hocus:text-primary-500 transition duration-300`}
    .icon {
      ${tw`fill-current w-6 h-6`}
    }
  }
`

export default ({
  heading = "Our Team",
  subheading = "",
  description = "We are a growing team of digital solutions experts and thought leaders, full of personality and ready to help you with the best tools.",
  cards = [
    {
      imageSrc: "https://i.postimg.cc/RCwXYRbF/IMG-9685.jpg",
      position: "CTO / Co-Founder",
      name: "Harold Avenia",
      links: [
        {
          url: "https://www.linkedin.com/in/haroldavenia/",
          icon: LinkedinIcon,
        }
      ],
    },
    {
      imageSrc: "https://i.postimg.cc/HnK7vQmg/Image-1-2.jpg",
      position: "Co-Founder",
      name: "Cristian Guevara",
      links: [
        {
          url: "https://www.linkedin.com/in/cristianjw/",
          icon: LinkedinIcon,
        },
      ],
    },
  ]
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading> }
          {description && <Description>{description}</Description> }
        </HeadingContainer>
        <Cards>
          {cards.map((card, index) => (
            <Card key={index}>
              <LazyImage imageSrc={card.imageSrc} />
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name">{card.name}</span>
                <CardLinks>
                  {card.links.map((link, linkIndex) => (
                    <a key={linkIndex} className="link" href={link.url}>
                      <link.icon className="icon" />
                    </a>
                  ))}
                </CardLinks>
              </CardContent>
            </Card>
          ))}
        </Cards>
      </ContentWithPaddingXl>
    </Container>
  );
};
